import { useAuth0 } from "@auth0/auth0-react";
import { Autocomplete, Button, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { ArrowLeft, Calendar, Search, X } from "react-feather";
import { toast } from "react-smart-toaster";
import styles from "../smartdevices.module.css";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AddLogCallAPI } from "../../../components/AddLogs";
import DateRangePicker from "rsuite/DateRangePicker";
import moment from "moment";
import { TableLoader } from "../../../components/LoaderC";
import dayjs from "dayjs";

const schema = yup.object().shape({
    property_id: yup.string().required("This field is Required"),
    apt_id: yup.string().required("This field is Required"),
});

const AddDeviceFormNew = ({ setShowAddFormNew, setLoading, setSnackbarOpen, setSnackbarMsg, onSubmitLocal, apartmentData }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [cuurentStep, setCuurentStep] = useState(1);
    const [propertyList, setPropertyList] = useState([]);
    const [apartmentList, setApartmentList] = useState([]);
    const [selectPropertyId, setSelectPropertyId] = useState(0);
    const [locationData, setLocationData] = useState(null);
    const [selectedPropertyName, setSelectedPropertyName] = useState('');
    const [selectedAptName, setSelectedAptName] = useState('');
    const [filterObj, setFilterObj] = useState({ type: '', status: '', iot: '' });
    const [searchKey, setSearchKey] = useState("");
    const [defaultDateFilter, setDefaultDateFilter] = useState(null);
    const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);
    const [allTuyaDeviceList, setAllTuyaDeviceList] = useState([]);
    const [tuyaDeviceList, setTuyaDeviceList] = useState([]);
    const [deviceList, setDeviceList] = useState([]);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [accountErrMsg, setAccountErrMsg] = useState('');
    const [deviceIds, setDeviceIds] = useState([]);

    const { handleSubmit, control, setValue, errors, clearErrors } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            property_id: '',
            apt_id: '',
        }
    });

    useEffect(() => {
        const fetchPropertyList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/properties", {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };
        fetchPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        console.log('apartmentData');
        console.log(apartmentData);

        if (apartmentData && apartmentData?.property_id && apartmentData?.apt_id) {
            setLocationData(apartmentData);
            setCuurentStep(2);

            setSelectedPropertyName('');
            setSelectedAptName('');

            let apartmentListTemp = [];
            propertyList?.map(i => {
                if (i.value === parseInt(apartmentData?.property_id)) {
                    apartmentListTemp = i.apartments;
                }
                return null;
            });

            let sProperty = propertyList?.filter(i => i?.value === parseInt(apartmentData?.property_id));
            let sApt = apartmentListTemp?.filter(i => i?.value === parseInt(apartmentData?.apt_id));

            if (sProperty.length > 0) {
                setSelectedPropertyName(sProperty[0]?.label);
            }
            if (sApt.length > 0) {
                setSelectedAptName(sApt[0]?.label);
            }

            setContentLoading(true);
            getAccountDetails(apartmentData);
        }
    }, [apartmentData, propertyList])

    const selectProperty = (val1, val2) => {
        console.log(11111111);
        console.log(val1);
        let apartmentListTemp = [];
        propertyList?.map(i => {
            if (i.value === val1) {
                apartmentListTemp = i.apartments;
            }
            return null;
        });

        setValue('apt_id', val2);
        setApartmentList(apartmentListTemp);
        setSelectPropertyId(val1);

        clearErrors();
    }

    const onSubmit = (data) => {
        setLocationData(data);
        setCuurentStep(2);

        setSelectedPropertyName('');
        setSelectedAptName('');

        let sProperty = propertyList?.filter(i => i?.value === parseInt(data?.property_id));
        let sApt = apartmentList?.filter(i => i?.value === parseInt(data?.apt_id));

        if (sProperty.length > 0) {
            setSelectedPropertyName(sProperty[0]?.label);
        }
        if (sApt.length > 0) {
            setSelectedAptName(sApt[0]?.label);
        }

        setContentLoading(true);
        getAccountDetails(data);
    }

    const backToStep1 = () => {
        setCuurentStep(1);
        setAllTuyaDeviceList([]);
        setTuyaDeviceList([]);
        setDeviceList([]);

        setTimeout(() => {
            setValue('property_id', parseInt(locationData?.property_id));
        }, 300);

        setTimeout(() => {
            selectProperty(parseInt(locationData?.property_id), parseInt(locationData?.apt_id));
        }, 500);
    }

    const getLocationVal = (id) => {
        if (selectedDeviceIds.indexOf(id) > -1) {
            let deviceTemp = selectedDevices?.filter(i => i?.id === id);
            if (deviceTemp?.length > 0) {
                return deviceTemp[0]?.location;
            }
        }
        return '';
    }

    const getAccountDetails = async (data) => {
        setAccountErrMsg('');
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/tuya-account-details", {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: data
        }).then((response) => {
            getIoTDeviceList(response.data.data);
            getDeviceList(response.data.data);
        }).catch((error) => {
            setContentLoading(false);
            setAccountErrMsg('Selected apartment does not have any IoT account configured.')
        });
    }

    const getIoTDeviceList = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/all-iot-devices", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: data
        }).then((response) => {
            setContentLoading(false);
            setAllTuyaDeviceList(response.data.data?.map(i => {
                return { ...i, type: 'Tuya' }
            }));
        }).catch((error) => {
            setContentLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const getDeviceList = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/device-ids/" + data?.project_id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setDeviceIds(response.data.data);
        }).catch((error) => { });
    }

    useEffect(() => {
        if (allTuyaDeviceList.length) {
            let tempDeviceList = allTuyaDeviceList.filter(i => deviceIds.indexOf(i.id) === -1);
            tempDeviceList.sort((a, b) => a.active_time < b.active_time ? 1 : -1)

            setTuyaDeviceList(tempDeviceList);
        }
    }, [deviceIds, allTuyaDeviceList]);

    useEffect(() => {
        if (tuyaDeviceList.length) {
            let tempDeviceList = tuyaDeviceList;

            if (searchKey !== '') {
                let inputVal = searchKey;
                inputVal = inputVal.toLowerCase();

                tempDeviceList = tempDeviceList.filter((item) => {
                    return (item?.id?.toLowerCase().includes(inputVal) || item?.name?.toLowerCase().includes(inputVal) || item?.product_name?.toLowerCase().includes(inputVal));
                });
            }

            if (defaultDateFilter) {
                tempDeviceList = tempDeviceList.filter(i => {
                    if (dayjs(dayjs.unix(i?.active_time).format("YYYY-MM-DD")).isBetween(dayjs(defaultDateFilter[0]).format("YYYY-MM-DD"), dayjs(defaultDateFilter[1]).format("YYYY-MM-DD"), undefined, [])) {
                        return true;
                    }
                    return false;
                })
            }

            if (filterObj?.type !== '' && filterObj?.type !== 'all') {
                tempDeviceList = tempDeviceList.filter((i) => i.product_name === filterObj.type);
            }

            if (filterObj?.status !== '' && filterObj?.status !== 'all') {
                if (filterObj?.status === 'online') {
                    tempDeviceList = tempDeviceList.filter((i) => i.online);
                }
                if (filterObj?.status === 'offline') {
                    tempDeviceList = tempDeviceList.filter((i) => !i.online);
                }
            }

            setDeviceList(tempDeviceList);
        }
    }, [tuyaDeviceList, defaultDateFilter, searchKey, filterObj]);

    const addDevices = async () => {
        if (selectedDeviceIds.length === 0) {
            toast.error('Please select device.');
            return false;
        }
        setShowAddFormNew(false);
        setLoading(true);
        let data = {};
        data = { ...locationData, devices: selectedDevices };

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/add-devices", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let rData = response.data.data;
            onSubmitLocal(rData);

            rData?.map(item => {
                let logData = {
                    'title': 'New smart device is created',
                    'description': [
                        'Device name: ' + item.name,
                        'Device id: ' + item.deviceID,
                        'Product type: ' + item.product_type,
                        'Location: ' + item.location
                    ]
                }
                AddLogCallAPI(logData, token);

                return false;
            });

        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return (<>
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => setShowAddFormNew(false)}><ArrowLeft /></button>
            Add Device
            <button onClick={(e) => setShowAddFormNew(false)}><X /></button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
            {cuurentStep === 1 && <div className={`${styles.ModalFormGroupTwo}`}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <p className={`${styles.AddDeviceFormTitle}`}>Location</p>
                    <div className={`${styles.AddDeviceFormTwo}`}>
                        <div className={`${styles.AddDeviceFormRow}`}>
                            <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Property*</InputLabel>
                                    <Controller
                                        name="property_id"
                                        control={control}
                                        render={(field) => (
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Property*"
                                                onChange={(e) => { field.onChange(e); selectProperty(e.target.value, ''); }}
                                            >
                                                {propertyList.map(i => {
                                                    return <MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>
                                                })}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors?.property_id && (<p className={`${styles.ErrorM}`}>{errors?.property_id?.message}</p>)}
                            </div>
                            <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="apt_id"
                                        control={control}
                                        render={(field) => (<Autocomplete
                                            options={apartmentList || []}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={apartmentList?.find((opt) => opt.value === field.value) || null}
                                            renderInput={(params) => (<TextField {...params} label="Select Apartment*" />)}
                                            noOptionsText={selectPropertyId ? "No apartments found" : "Select property first"}
                                            onChange={(event, newValue) => {
                                                field.onChange(newValue?.value || null);
                                                clearErrors("apt_id");
                                            }}
                                        />)}
                                    />
                                </FormControl>
                                {errors.apt_id && (<p className={`${styles.ErrorM}`}>{errors.apt_id.message}</p>)}
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.ButtonAction}`}>
                        <Button className="CancelPopupBU" type="button" onClick={(e) => setShowAddFormNew(false)}>Cancel</Button>
                        <Button className="SubmitPopupBU" type="submit">Next</Button>
                    </div>
                </form>
            </div>}
            {cuurentStep === 2 && <div className={`${styles.ModalFormGroup}`}>
                <form>
                    <p className={`${styles.AddDeviceFormTitle}`}>Location: <span>{selectedPropertyName} - {selectedAptName}</span></p>
                    <div className={`${styles.AddDeviceSec}`}>
                        <div className={`${styles.SearchConSec}`}>
                            <Search />
                            <input type="text" placeholder="Search" onChange={(e) => setSearchKey(e.target.value)} />
                        </div>
                        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} FormGroup AddDevice`}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Device Type</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Device Type"
                                    value={filterObj?.type}
                                    onChange={(e) => {
                                        setFilterObj((prev) => {
                                            return { ...prev, type: e.target.value };
                                        });
                                    }}
                                >
                                    <MenuItem value={'all'}>All</MenuItem>
                                    <MenuItem value={'Smart Dimmer Switch'}>Smart Dimmer Switch</MenuItem>
                                    <MenuItem value={'Thermostat'}>Thermostat</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} FormGroup AddDevice`}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Status"
                                    value={filterObj?.status}
                                    onChange={(e) => {
                                        setFilterObj((prev) => {
                                            return { ...prev, status: e.target.value };
                                        });
                                    }}
                                >
                                    <MenuItem value={'all'}>All</MenuItem>
                                    <MenuItem value={'online'}>Online</MenuItem>
                                    <MenuItem value={'offline'}>Offline</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className={`${styles.AddDeviceDatePick} FormGroup AddDevice`}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">IOT Type</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={filterObj?.iot}
                                    onChange={(e) => {
                                        setFilterObj((prev) => {
                                            return { ...prev, iot: e.target.value };
                                        });
                                    }}
                                >
                                    <MenuItem value="Tuya">Tuya</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className={`${styles.AddDeviceDatePick} DashFilterSec AddDevice`}>
                            <DateRangePicker
                                format={"M/d/yy"}
                                placeholder={"Filter by date"}
                                placement={"bottomEnd"}
                                caretAs={Calendar}
                                showOneCalendar
                                onChange={(e) => setDefaultDateFilter(e)}
                            />
                        </div>
                    </div>
                    {allTuyaDeviceList?.length > 0 && <p className={`${styles.DeviceSelectedMSG}`}>{(selectedDeviceIds?.length > 0 ? (selectedDeviceIds?.length > 1 ? selectedDeviceIds?.length + ' devices selected' : selectedDeviceIds?.length + ' device selected') : 'No device selected')}</p>}

                    {contentLoading && <div className="Loader TableLoader">
                        <TableLoader />
                    </div>}

                    {!contentLoading && <div className={`${styles.AddDeviceRow}`}>
                        {accountErrMsg ?
                            <div className={`${styles.AddDeviceErrorMsg}`}>
                                <div className={`${styles.AddDeviceErrorMsgIMG}`}>
                                    <img src="/static/img/no-linked.png" alt="No Data" />
                                </div>
                                <p>{accountErrMsg}</p>
                            </div>
                            : (tuyaDeviceList?.length === 0 ?
                                <div className={`${styles.AddDeviceErrorMsg}`}>
                                    <div className={`${styles.AddDeviceErrorMsgIMG}`}>
                                        <img src="/static/img/no-linked.png" alt="No Data" />
                                    </div>
                                    <p>No devices are linked to this account</p>
                                </div>                                
                                : (deviceList?.length === 0 && 
                                    <div className={`${styles.AddDeviceErrorMsg}`}>
                                        <div className={`${styles.AddDeviceErrorMsgIMG}`}>
                                            <img src="/static/img/no-linked.png" alt="No Data" />
                                        </div>
                                        <p>No devices match your current filter criteria.</p>
                                    </div> 
                                ))}
                        {deviceList?.map((item, index) => {
                            return (<div className={`${styles.AddDeviceList}`} key={index}>
                                <div className={selectedDeviceIds.indexOf(item?.id) > -1 ? `${styles.AddDeviceListUnder} ${styles.Active}` : `${styles.AddDeviceListUnder}`}>
                                    <div className={`${styles.AddDeviceListHeadSec}`}>
                                        <div className={`${styles.AddDeviceListIconSec}`}>
                                            {(item?.product_name === 'Smart Dimmer Switch' ? <img src="/static/img/bulb.svg" width="24px" height="24px" alt="" /> : (item?.product_name === 'Thermostat' ? <img src="/static/img/temperature.svg" width="24px" height="24px" alt="" /> : <img src="/static/img/smart-device-default.svg" width="24px" height="24px" alt="" />))}
                                        </div>
                                        <div className={`${styles.AddDeviceListTitleSec}`}>
                                            <p className={`${styles.AddDeviceListTitle}`}>
                                                <Tooltip title={item.name} placement="bottom-start">{item?.name}</Tooltip>
                                                {item?.online && <span className={`${styles.OpenBadge}`}>Online</span>}
                                                {!item?.online && <span className={`${styles.OfflineBadge}`}>Offline</span>}
                                            </p>
                                            <p className={`${styles.AddDeviceListTitle}`}><Tooltip title={item?.product_name} placement="bottom-start">{item?.product_name}</Tooltip></p>
                                        </div>
                                    </div>
                                    <div className={`${styles.ProspectCardFootSec}`}>
                                        <p className={`${styles.ProsCardDate}`}>{moment.unix(item?.active_time).fromNow()}</p>
                                        <div className={selectedDeviceIds.indexOf(item?.id) > -1 ? `${styles.MainReqConDropBU} FormGroup SelectRoom Active` : `${styles.MainReqConDropBU} FormGroup SelectRoom`}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Select Room</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Select Room"
                                                    value={getLocationVal(item?.id)}
                                                    onChange={(e) => {
                                                        if (selectedDeviceIds.indexOf(item?.id) === -1) {
                                                            setSelectedDeviceIds(prev => {
                                                                return prev.concat([item?.id]);
                                                            });
                                                            setSelectedDevices(prev => {
                                                                return prev.concat([{ id: item?.id, name: item?.name, online: item?.online, location: e.target.value, product_name: item?.product_name, type: item?.type }]);
                                                            });
                                                        } else {
                                                            setSelectedDevices(prev => {
                                                                return prev.map(i => {
                                                                    if (i?.id === item?.id)
                                                                        return { ...i, location: e.target.value };
                                                                    return i;
                                                                });
                                                            });
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value={'Bedroom'}>Bedroom</MenuItem>
                                                    <MenuItem value={'Bedroom Closet'}>Bedroom Closet</MenuItem>
                                                    <MenuItem value={'Bathroom'}>Bathroom</MenuItem>
                                                    <MenuItem value={'Living Room'}>Living Room</MenuItem>
                                                    <MenuItem value={'Living Room Closet'}>Living Room Closet</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <button className={`${styles.ResetRoomSelect}`} type="button" onClick={(e) => {
                                                setSelectedDeviceIds(prev => {
                                                    return prev.filter(i => i !== item?.id);
                                                });
                                                setSelectedDevices(prev => {
                                                    return prev.filter(i => i?.id !== item?.id);
                                                });
                                            }}><X /></button>
                                        </div>
                                    </div>
                                </div>
                            </div>);
                        })}
                    </div>}
                    <div className={`${styles.ButtonAction}`}>
                        {apartmentData ? <Button className="CancelPopupBU" type="button" onClick={(e) => setShowAddFormNew(false)}>Cancel</Button> : <Button className="CancelPopupBU" type="button" onClick={(e) => backToStep1()}>Back</Button>}
                        <Button className="SubmitPopupBU" type="button" onClick={(e) => addDevices()}>Add</Button>
                    </div>
                </form>
            </div>}
        </DialogContent>
    </>);
}

export default AddDeviceFormNew;